import BaseXMLGenerator from './xlsx-tableexport-generator.js';
import AppDataSetting from '@/data/app-data-setting.js'

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []

        let emptyCount = vm.$store.getters.users.filter(
            o => AppDataSetting.findUserDepartmentID(vm, o) == data.ID
        ).length;

        row.push(data.Name)
        row.push(emptyCount)

        rows.push(row)
    }
    let headerList = ['部門名稱', '部門人數']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;